import { UserMenu } from "@/components/UserMenu";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { SmplifyLogo } from "@/components/SmplifyLogo";

interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export function Header({ className, children, ...props }: HeaderProps) {
  return (
    <header
      className={cn(
        "flex min-h-14 md:min-h-16 md:h-16 items-center gap-2 md:gap-4 border-b border-border bg-background/95 backdrop-blur-md px-3 md:px-4 overflow-hidden",
        className,
      )}
      style={{
        paddingTop: "env(safe-area-inset-top)",
        boxSizing: "content-box",
      }}
      {...props}
    >
      {children}
      <div className="flex items-center md:ml-[-1rem]">
        <Link to="/getting-started" aria-label="Smplify home">
          <SmplifyLogo
            size="header"
            className="cursor-pointer hover:opacity-90 transition-opacity"
          />
        </Link>
      </div>
      <div className="hidden sm:flex items-center ml-[-1rem]">
        <Separator orientation="vertical" className="h-4 mx-1" />
        <span className="text-sm font-medium text-brand-main">Partner Portal</span>
      </div>
      <div className="flex-1" />
      <div className="flex items-center gap-1 md:gap-2">
        <UserMenu />
      </div>
    </header>
  );
}
